import { useContext, useEffect } from 'react';
import { getExperimentVariant } from '@buzzfeed/react-components/lib/utils/abeagle';
import { ABeagleContext } from '@buzzfeed/react-components';
import { attachClientTimeSpentHandler } from '../../hooks/analytics/client-event-tracking';
import { useProfileUserLayer } from '../../hooks/analytics/useUserLayers';

/**
 * Serves the purpose of rolling out TimeSpentTracking. Once fully rolled out, we will remove this.
 */
export default function TimeSpentTracking({layers = []}) {
  const profileUserLayer = useProfileUserLayer();
  const { experiments } = useContext(ABeagleContext);

  useEffect(() => {
    let time_spent_handler = () => {};
    if (!experiments.stale && experiments.loaded) {
      const variant = getExperimentVariant(experiments, 'TimeSpentRO_2',
        { rejectErrors: false });
      if (variant === 'on') {
        time_spent_handler = attachClientTimeSpentHandler(profileUserLayer(), ...layers);
      }
    }
    return time_spent_handler;
  }, [experiments.loaded, layers]);

  return null;
}
